import { Routes, Route } from "react-router-dom";
import Pages from "./pages";
import MainContainer from "./layout/MainContainer";

const Routing = () => {
  return (
    <Routes>
        <Route path="/" element={<Pages.Login />} />
        <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
        <Route path="/otp" element={<Pages.OtpVerification />} />
        <Route path="/reset-password" element={<Pages.ResetPassword />} />
        <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/manage-users" element={<Pages.ManageCustomers />} />
        <Route path="/manage-users/detail" element={<Pages.ManageCustomerDetail />} />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-service-categories" element={<Pages.ManageCategories />} />
        <Route path="/manage-service-categories/sub-categories" element={<Pages.ManageSubCategories />} />
        <Route path="/manage-revenue" element={<Pages.ManageRevenue />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route path="/manage-subadmin/detail" element={<Pages.SubadminDetail />} />
        <Route path="/manage-subadmin/roles" element={<Pages.ManageSubadminRoles />} />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route path="/manage-subadmin/roles/detail" element={<Pages.RoleDetail />} />
        <Route path="/manage-subscriptions" element={<Pages.ManageSubscriptions />} />
        <Route path="/manage-subscriptions/add" element={<Pages.AddSubscription />} />
        <Route path="/manage-subscriptions/detail" element={<Pages.ManageSubscriptionDetail />} />
        <Route path="/manage-customer-support" element={<Pages.ManageCustomerSupport />} />
        <Route path="/manage-notifications" element={<Pages.ManageNotifications />} />
        <Route path="/recieved-notifications" element={<Pages.RecievedNotifications />} />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/settings" element={<Pages.Settings />} />
        <Route path="/geofencing" element={<Pages.GeoFencing />} />
        <Route path="/geofencing/add" element={<Pages.AddGeoFencing />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route path="/manage-profile/change-password" element={<Pages.ChangePassword />} />
        <Route path="/manage-bookings" element={<Pages.ManageBookings />} />
        <Route path="/manage-bookings/view" element={<Pages.ViewBookings />} />
        <Route path="/manage-reviews" element={<Pages.ManageReviews />} />
        <Route path="/manage-loyalty" element={<Pages.LoyaltyPoints />} />
          
        <Route path="/manage-service-providers" element={<Pages.ManageServiceProviders />} />
        <Route path="/manage-service-providers/edit" element={<Pages.EditServiceProvider />} />
        <Route path="/manage-service-providers/view" element={<Pages.ViewServiceProviders />} />
        <Route path="/manage-service-providers/add" element={<Pages.AddServiceProvider />} />
        <Route path="/manage-reports" element={<Pages.ManageReports />} />
      </Route>
    </Routes>
  );
};

export default Routing;
